import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

import { MatCheckboxChange } from '@angular/material/checkbox';
import { Logger } from '@app/core/logger.service';
import { AuthLoginResponse, ErrorDetails } from '@app/core/auth/auth.type';
import { AuthService } from '@app/core/auth/auth.service';
import { LocalStorageService } from '@app/core/services/local-storage.service';
import { environment } from '@env/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { TokenStorageService } from '@app/core/services/token-storage.service';
import { TokenService } from '@app/core/services/token.service';
import { I18nService } from '@app/core/i18n.service';
import { LoadingDialogService } from '@app/shared/components/loading/loading-dialog.service';

const log = new Logger('Login');

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  
  SYSTEM_UNDER_MAINTENANCE_LOCALIZED: string = $localize`:Under maintenance text |Text message displayed as under maintenance in login page@@SystemUnderMaintenanceMessage:Our system is currently undergoing maintenance. Please try again later.`; 
  
  errorDetails!: ErrorDetails;
  loginForm!: FormGroup;
  checked!: boolean;
  readUsePolicy! : boolean;
  culture: string | undefined;

  constructor(
    private _router: Router,
    private _formBuilder: FormBuilder,
    private _authService: AuthService,
    private _tokenService: TokenService,
    private _tokenStorageService: TokenStorageService,
    private _localStorageService: LocalStorageService,
    private _loadingDialogService: LoadingDialogService,
  ) {}

  
  /**
   * If the error type is 'INVALID_REQUEST' and the error code is 'VAUS1007', 
   * it computes the difference in minutes between the timestamp parsed from 
   * the error message in UTC and the current local timestamp. Otherwise, it 
   * returns 0, indicating no active countdown.
   */
  get tooManyAttemptsErrorSecondsToCountdown(): number {
    if (this.errorDetails.errorType.toUpperCase() == 'INVALID_REQUEST' && this.errorDetails.errorCode.toUpperCase() == 'VAUS1007') {
      let countdown = Math.round((new Date(this.errorDetails.errorMessage + "Z").getTime() - new Date().getTime()) / 1000);
      return countdown > 0 ? countdown : 0;
    } else {
      return 0;
    }
  }

  ngOnInit() {

    // form buidler
    this.loginForm = this._formBuilder.group({
      username: new FormControl({ value: '', disabled: false }, [Validators.email, Validators.required]),
      password: new FormControl({ value: '', disabled: false }, Validators.required),
      remember: true,
      // readPolicy: new FormControl({ value: '', disabled: false }, Validators.requiredTrue),
    });

    if(this._localStorageService.getItem(LocalStorageService.APP_REM_KEY)) {
      this.checked = true;
      this.loginForm.patchValue({ username: this._localStorageService.getItem(LocalStorageService.APP_REM_KEY) });
    } else {
      this.checked = false
    }

    this.culture = $localize.locale;
  }

  login() {
    /*
     * Start login by clearing local storage for this app to ensure a clear cache
     * with no saved tokens or email.
     */
    this._tokenStorageService.removeTokens()
    this._localStorageService.clear()
    
    if (this.checked) {
      this._localStorageService.setItem(LocalStorageService.APP_REM_KEY, this.loginForm.value.username)
    }

    const credentialsRequest = {
      email: this.loginForm.value.username,
      password: this.loginForm.value.password
    }

    this._loadingDialogService.openDialog()

    this._authService.authenticate(credentialsRequest).pipe(
      catchError((httpErrorResponse: HttpErrorResponse) => {
        this._loadingDialogService.hideDialog()
        this.errorDetails = httpErrorResponse.error
        throw httpErrorResponse
      }),
    ).subscribe((authLoginResponse: AuthLoginResponse) => {
      this._loadingDialogService.hideDialog()
      // Save login tokens upon succesful authentication
      this._tokenService.saveAccessToken(authLoginResponse.accessToken);
      this._tokenService.saveRefreshToken(authLoginResponse.refreshToken, authLoginResponse.refreshTokenExpiry);

      this._router.navigate(['home'], {});
    })
  }

  showOptions(event: MatCheckboxChange) {
    this.checked = event.checked;
  }

  termsOfUseResponse(event: MatCheckboxChange) {
    this.readUsePolicy = event.checked;
  }

  _redirectToForgotPasswordPage() {
    const url = 'https://onboardqi.com/#/reset-password';
    window.open(url);
  }

  openPrivacyPolicy(){
    
  }

  openTermsOfUse(){

  }
}